import "./App.css";
import { useEffect, useState } from "react";
import Characters from "./components/Characters/Characters";

function App() {
  const [CharacterList, setCharacterList] = useState([]);
  const [page, setPage] = useState(1);
  useEffect(() => {
    fetch(`https://rickandmortyapi.com/api/character?page=${page}`)
      .then((response) => response.json())
      .then((response) => setCharacterList(response.results))
      .catch((err) => console.log(err));
  }, [page]);

  const previousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const nextPage = () => {
    setPage(page + 1);
  };

  return (
    <div className="App">
      <header className="App-header">
        <Characters CharacterList={CharacterList} />
        <button onClick={() => previousPage()}>Anterior </button>
        <button onClick={() => nextPage()}>Próximo >> </button>
      </header>
    </div>
  );
}

export default App;
